import { PropsWithChildren } from 'react'
import Styles from './BackgroundsTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props
  extends PropsWithChildren<{
    name: string
  }> {}

export const SuggestedCategoriesGroup = (props: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.suggestedCategoriesGroup}>
      <Text variant={isMobile ? 'smallList' : 'largeList'}>{props.name}</Text>
      <div className={Styles.suggestedCategories}>{props.children}</div>
    </div>
  )
}
